<template>
  <div id="dashboard" class="container-fluid px-0 envio-sms-page">
    <section class="ps-lg-4 pe-lg-4 pb-2">
      <div class="envio-sms-formulario">
        <header id="seccionCabecera" class="envio-sms-cabecera">
          <p class="envio-sms-title-row">
            <span id="cabeceraDashboard" class="envio-sms-title">Enviar comunicación</span>
          </p>
          <b-form-group
            v-if="showOrigenSelector"
            label="Origen"
            label-for="envio-sms-origen"
            class="envio-sms-field envio-sms-origen"
          >
            <b-form-select
              id="envio-sms-origen"
              v-model="form.origen"
              :options="origenOptions"
            ></b-form-select>
          </b-form-group>
        </header>

        <b-form autocomplete="off" @submit.prevent="enviar">
          <div class="envio-sms-id-row envio-sms-clave">
            <b-form-group label-for="envio-sms-ticket-id" class="envio-sms-field">
              <template #label>
                ID de incidencia
                <span class="envio-sms-req" aria-hidden="true">*</span>
              </template>
              <b-form-input
                id="envio-sms-ticket-id"
                v-model="form.ticket_id"
                
                :class="{'is-invalid': fieldErrors.ticket_id}"
                :aria-invalid="fieldErrors.ticket_id ? 'true' : 'false'"
                @update:model-value="onTicketIdInput"
              ></b-form-input>
            </b-form-group>
            <b-form-group label-for="envio-sms-oceane" class="envio-sms-field">
              <template #label>
                Oceane
                <span class="envio-sms-mark">(opcional)</span>
              </template>
              <b-form-input
                id="envio-sms-oceane"
                v-model="form.oceane"
                @update:model-value="clearFieldError('oceane')"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="envio-sms-sheet">
            <div class="envio-sms-mando">
              <b-form-group label-for="envio-sms-lista" class="envio-sms-field">
                <template #label>
                  Lista de destinatarios
                  <span class="envio-sms-mark">(opcional)</span>
                </template>
                <b-form-select
                  id="envio-sms-lista"
                  v-model="form.lista_id"
                  :class="{'is-invalid': fieldErrors.lista_id}"
                  :options="listaOptions"
                  @update:model-value="clearFieldError('lista_id')"
                ></b-form-select>
              </b-form-group>

              <fieldset class="envio-sms-secuencia" :class="{'is-invalid': fieldErrors.sequence}">
                <legend class="envio-sms-severidad-label">
                  Secuencia
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </legend>
                <div class="envio-sms-secuencia-grid">
                  <label
                    v-for="choice in sequenceChoices"
                    :key="choice.value"
                    class="envio-sms-placa"
                    :title="tooltipSecuencia(choice)"
                    :class="[
                      'envio-sms-placa--' + choice.slug,
                      {'is-selected': form.sequence === choice.value},
                      {'is-disabled': secuenciaDeshabilitada(choice)},
                    ]"
                  >
                    <input
                      type="radio"
                      name="envio-sms-sequence"
                      :id="choice.value === 'Inicio' ? 'envio-sms-sequence' : undefined"
                      :value="choice.value"
                      v-model="form.sequence"
                      :disabled="secuenciaDeshabilitada(choice)"
                      :class="{'is-invalid': fieldErrors.sequence}"
                      @change="clearFieldError('sequence')"
                    />
                    <span class="envio-sms-placa-name">{{ nombreSecuencia(choice) }}</span>
                  </label>
                </div>
              </fieldset>

              <div
                class="envio-sms-severidad"
                role="radiogroup"
                aria-labelledby="envio-sms-severity-label"
              >
                <span id="envio-sms-severity-label" class="envio-sms-severidad-label">
                  Severidad
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </span>
                <label
                  v-for="choice in severityChoices"
                  :key="choice.value"
                  class="envio-sms-chip"
                  :class="[
                    'envio-sms-chip--' + choice.slug,
                    {'is-selected': form.severity === choice.value},
                  ]"
                >
                  <input
                    type="radio"
                    name="envio-sms-severity"
                    :id="choice.value === 'Crítica' ? 'envio-sms-severity' : undefined"
                    :value="choice.value"
                    v-model="form.severity"
                    :class="{'is-invalid': fieldErrors.severity}"
                    @change="clearFieldError('severity')"
                  />
                  {{ choice.value }}
                </label>
              </div>
            </div>

            <div class="envio-sms-datos">
              <b-form-group label-for="envio-sms-short-description" class="envio-sms-field">
                <template #label>
                  Descripción corta
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-input
                  id="envio-sms-short-description"
                  v-model="form.short_description"
                  :class="{'is-invalid': fieldErrors.short_description}"
                  :aria-invalid="fieldErrors.short_description ? 'true' : 'false'"
                  @update:model-value="clearFieldError('short_description')"
                ></b-form-input>
              </b-form-group>
              <b-form-group label-for="envio-sms-incident-manager" class="envio-sms-field">
                <template #label>
                  Gestor de incidencia
                  <span class="envio-sms-mark">(opcional)</span>
                </template>
                <b-form-input
                  id="envio-sms-incident-manager"
                  v-model="form.incident_manager"
                  :class="{'is-invalid': fieldErrors.incident_manager}"
                  @update:model-value="clearFieldError('incident_manager')"
                ></b-form-input>
              </b-form-group>
              <b-form-group label-for="envio-sms-communication-date" class="envio-sms-field">
                <template #label>
                  Fecha de inicio
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-input
                  id="envio-sms-communication-date"
                  v-model="form.communication_date"
                  type="date"
                  :class="{'is-invalid': fieldErrors.communication_date}"
                  :aria-invalid="fieldErrors.communication_date ? 'true' : 'false'"
                  @update:model-value="clearFieldError('communication_date')"
                ></b-form-input>
              </b-form-group>
              <b-form-group label-for="envio-sms-communication-time" class="envio-sms-field">
                <template #label>
                  Hora de inicio
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-input
                  id="envio-sms-communication-time"
                  v-model="form.communication_time"
                  type="time"
                  :class="{'is-invalid': fieldErrors.communication_time}"
                  :aria-invalid="fieldErrors.communication_time ? 'true' : 'false'"
                  @update:model-value="clearFieldError('communication_time')"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="envio-sms-fin">
              <b-form-checkbox
                id="envio-sms-fin-impacto"
                v-model="form.declare_end_impact"
                class="envio-sms-fin-check"
              >
                Declarar fin de impacto
              </b-form-checkbox>
              <b-form-group
                v-if="form.declare_end_impact"
                label-for="envio-sms-end-date"
                class="envio-sms-field envio-sms-field-fecha"
              >
                <template #label>
                  Fecha de fin
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-input
                  id="envio-sms-end-date"
                  v-model="form.end_impact_date"
                  type="date"
                  :class="{'is-invalid': fieldErrors.end_impact_date}"
                  :aria-invalid="fieldErrors.end_impact_date ? 'true' : 'false'"
                  @update:model-value="clearFieldError('end_impact_date')"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="form.declare_end_impact"
                label-for="envio-sms-end-time"
                class="envio-sms-field envio-sms-field-hora"
              >
                <template #label>
                  Hora de fin
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-input
                  id="envio-sms-end-time"
                  v-model="form.end_impact_time"
                  type="time"
                  :class="{'is-invalid': fieldErrors.end_impact_time}"
                  :aria-invalid="fieldErrors.end_impact_time ? 'true' : 'false'"
                  @update:model-value="clearFieldError('end_impact_time')"
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="envio-sms-grid-3">
              <b-form-group label-for="envio-sms-prevision" class="envio-sms-field">
                <template #label>
                  Previsión
                  <span class="envio-sms-mark">(opcional)</span>
                </template>
                <b-form-input id="envio-sms-prevision" v-model="form.prevision"></b-form-input>
              </b-form-group>
              <b-form-group label-for="envio-sms-province" class="envio-sms-field">
                <template #label>
                  Provincia
                  <span class="envio-sms-mark">(opcional)</span>
                </template>
                <b-form-input id="envio-sms-province" v-model="form.province"></b-form-input>
              </b-form-group>
              <b-form-group label-for="envio-sms-site" class="envio-sms-field">
                <template #label>
                  Emplazamiento
                  <span class="envio-sms-mark">(opcional)</span>
                </template>
                <b-form-input id="envio-sms-site" v-model="form.site"></b-form-input>
              </b-form-group>
            </div>

            <div class="envio-sms-grid-4">
              <b-form-group label-for="envio-sms-affected-customer" class="envio-sms-field">
                <template #label>
                  Impacto
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-textarea
                  id="envio-sms-affected-customer"
                  v-model="form.affected_customer"
                  rows="3"
                  :class="{'is-invalid': fieldErrors.affected_customer}"
                  :aria-invalid="fieldErrors.affected_customer ? 'true' : 'false'"
                  @update:model-value="clearFieldError('affected_customer')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group label-for="envio-sms-affected-services" class="envio-sms-field">
                <template #label>
                  Servicios afectados
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-textarea
                  id="envio-sms-affected-services"
                  v-model="form.affected_services"
                  rows="3"
                  :class="{'is-invalid': fieldErrors.affected_services}"
                  :aria-invalid="fieldErrors.affected_services ? 'true' : 'false'"
                  @update:model-value="clearFieldError('affected_services')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group label-for="envio-sms-affected-equipment" class="envio-sms-field">
                <template #label>
                  Nodos afectados
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-textarea
                  id="envio-sms-affected-equipment"
                  v-model="form.affected_equipment"
                  rows="3"
                  placeholder="Separa cada equipo con una coma, un espacio o un punto y coma."
                  aria-describedby="envio-sms-equipos-hint"
                  :class="{'is-invalid': fieldErrors.affected_equipment}"
                  :aria-invalid="fieldErrors.affected_equipment ? 'true' : 'false'"
                  @update:model-value="clearFieldError('affected_equipment')"
                ></b-form-textarea>
                <span id="envio-sms-equipos-hint" class="visually-hidden">
                  Separa cada equipo con una coma, un espacio o un punto y coma.
                </span>
              </b-form-group>
              <b-form-group label-for="envio-sms-message" class="envio-sms-field envio-sms-acciones">
                <template #label>
                  Acciones en curso
                  <span class="envio-sms-req" aria-hidden="true">*</span>
                </template>
                <b-form-textarea
                  id="envio-sms-message"
                  v-model="form.message"
                  rows="3"
                  class="envio-sms-resizable"
                  :class="{'is-invalid': fieldErrors.message}"
                  :aria-invalid="fieldErrors.message ? 'true' : 'false'"
                  @update:model-value="clearFieldError('message')"
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="envio-sms-footer">
              <div class="envio-sms-footer-status">
                <div class="envio-sms-footer-alerts" aria-live="polite">
                  <b-alert
                    v-if="showSuccessAlert"
                    v-model="showSuccessAlert"
                    variant="success"
                    dismissible
                    class="mb-0"
                    fade
                  >
                    {{ successAlertText }}
                  </b-alert>
                  <b-alert
                    v-if="showWarningAlert"
                    v-model="showWarningAlert"
                    variant="warning"
                    dismissible
                    class="mb-0"
                    fade
                  >
                    {{ warningAlertText }}
                  </b-alert>
                  <b-alert
                    v-if="showErrorAlert"
                    v-model="showErrorAlert"
                    variant="danger"
                    dismissible
                    class="mb-0"
                    fade
                  >
                    {{ errorAlertText }}
                  </b-alert>
                </div>
                <p
                  id="envio-sms-listo"
                  class="envio-sms-ready"
                  :class="{'envio-sms-ready--faltan': faltanCampos}"
                >{{ faltanTexto }}</p>
              </div>
              <div class="envio-sms-footer-actions">
                <b-button type="button" variant="outline-secondary" @click="limpiar">
                  Limpiar
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  aria-describedby="envio-sms-listo"
                  :disabled="sending || !permisosCargados || incidenciaCerrada"
                  :aria-busy="sending ? 'true' : 'false'"
                >
                  <b-spinner v-if="sending" small label="Enviando" class="me-2"></b-spinner>
                  Enviar
                </b-button>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </section>
  </div>
</template>

<script>
import auth from '../auth.js';
import {
  applyComunicadoAnterior,
  ENVIO_SMS_ANTERIOR_DEBOUNCE_MS,
  sequenceAfterComunicadoAnterior,
  shouldApplyComunicadoAnterior,
} from '../envioSmsAnterior.js';
import {
  emptyEnvioSmsForm,
  ENVIO_SMS_SEQUENCES,
  ENVIO_SMS_SEVERITIES,
  SELECT_PLACEHOLDER,
  currentEnvioSmsDateTime,
} from '../envioSmsCatalogs.js';
import {defaultEnvioSmsOrigen} from '../envioSmsPermisos.js';
import {envioResultAlert} from '../envioSmsResult.js';
import {
  assembleEnvioSmsPayload,
  validateEnvioSmsForm,
} from '../envioSmsValidation.js';

const ENVIAR_COOLDOWN_MS = 500;
const ALERT_DISMISS_MS = 6000;
const GENERIC_ERROR_ALERT_TEXT = 'Ocurrió un error.';
const INCIDENCIA_CERRADA = 'Esta incidencia ya está cerrada. No se puede enviar otro comunicado.';

const FALTAN_ORDER = [
  ['sequence', 'secuencia'],
  ['severity', 'severidad'],
  ['ticket_id', 'ID de incidencia'],
  ['communication_date', 'fecha'],
  ['communication_time', 'hora'],
  ['end_impact_date', 'fecha de fin de impacto'],
  ['end_impact_time', 'hora de fin de impacto'],
  ['short_description', 'descripción corta'],
  ['affected_customer', 'impacto'],
  ['affected_services', 'servicios afectados'],
  ['affected_equipment', 'nodos afectados'],
  ['message', 'acciones en curso'],
];

function choiceSlug(value) {
  return String(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function joinFaltan(items) {
  const shown = items.slice(0, 3);
  const rest = items.length - shown.length;
  const verb = items.length === 1 ? 'Falta' : 'Faltan';
  if (rest > 0) {
    return verb + ' ' + shown.join(', ') + ' y ' + rest + ' más.';
  }
  if (shown.length === 1) return verb + ' ' + shown[0] + '.';
  return verb + ' ' + shown.slice(0, -1).join(', ') + ' y ' + shown[shown.length - 1] + '.';
}

function listaSelectOptions(listas) {
  return [
    {value: '', text: SELECT_PLACEHOLDER},
    ...(listas || []).map((lista) => ({value: lista.id, text: lista.nombre})),
  ];
}

export default {
  name: 'EnvioSms',
  data() {
    return {
      form: emptyEnvioSmsForm(''),
      fieldErrors: {},
      sending: false,
      showSuccessAlert: false,
      showWarningAlert: false,
      showErrorAlert: false,
      successAlertText: '',
      warningAlertText: '',
      errorAlertText: '',
      effectiveOrigenes: [],
      permisosCargados: false,
      aperturaBloqueada: false,
      incidenciaCerrada: false,
      siguienteSeguimiento: null,
      listaOptions: listaSelectOptions([]),
      sequenceChoices: ENVIO_SMS_SEQUENCES.map((value) => ({
        value,
        slug: choiceSlug(value),
      })),
      severityChoices: ENVIO_SMS_SEVERITIES.map((value) => ({
        value,
        slug: choiceSlug(value),
      })),
    };
  },
  computed: {
    defaultOrigen() {
      return defaultEnvioSmsOrigen(this.effectiveOrigenes);
    },
    showOrigenSelector() {
      return this.effectiveOrigenes.length > 0;
    },
    origenOptions() {
      return this.effectiveOrigenes.map((value) => ({value, text: value}));
    },
    faltanTexto() {
      if (!this.permisosCargados) return 'Esperando el origen permitido.';
      if (this.incidenciaCerrada) return 'Esta incidencia ya está cerrada.';
      const errors = validateEnvioSmsForm(this.form).fieldErrors;
      const items = FALTAN_ORDER.filter(([key]) => errors[key]).map(([, label]) => label);
      if (items.length === 0) return 'Listo para enviar.';
      return joinFaltan(items);
    },
    faltanCampos() {
      return this.faltanTexto.startsWith('Falta');
    },
  },
  watch: {
    'form.ticket_id'() {
      this.scheduleComunicadoAnterior();
    },
    'form.oceane'() {
      this.scheduleComunicadoAnterior();
    },
    'form.declare_end_impact'(declared) {
      if (declared) {
        const now = currentEnvioSmsDateTime(new Date());
        this.form.end_impact_date = now.communication_date;
        this.form.end_impact_time = now.communication_time;
      } else {
        this.form.end_impact_date = '';
        this.form.end_impact_time = '';
        this.clearFieldError('end_impact_date');
        this.clearFieldError('end_impact_time');
      }
    },
    'form.origen'(origen, previous) {
      if (previous !== origen) {
        this.form.lista_id = '';
      }
      this.cargarListasDestinatarios(origen);
    },
  },
  created() {
    this._formEpoch = 0;
    this._anteriorRequestId = 0;
    this.$store.state.botonEditar = false;
    this.$store.state.editar = false;
    this.cargarPermisosOrigen();
  },
  beforeUnmount() {
    clearTimeout(this._enviarCooldownTimer);
    clearTimeout(this._anteriorTimer);
    clearTimeout(this._alertTimer);
  },
  methods: {
    clearFieldError(field) {
      if (!this.fieldErrors[field]) return;
      const next = {...this.fieldErrors};
      delete next[field];
      this.fieldErrors = next;
    },
    async cargarPermisosOrigen() {
      try {
        const response = await fetch('api/permisos', {
          method: 'GET',
          headers: auth.getAuthHeader(),
        });
        const data = await response.json();
        this.effectiveOrigenes = (data[0] && data[0].origenes) || [];
        this.form.origen = this.defaultOrigen || '';
        this.permisosCargados = Boolean(this.defaultOrigen);
      } catch (error) {
        console.error('Error al comprobar permisos de Envío SMS', error);
      }
    },
    async cargarListasDestinatarios(origen) {
      if (!origen) {
        this.listaOptions = listaSelectOptions([]);
        return;
      }
      try {
        const response = await fetch(
          'api/envio-sms/listas?origen=' + encodeURIComponent(origen),
          {
            method: 'GET',
            headers: auth.getAuthHeader(),
          },
        );
        if (!response.ok) {
          this.listaOptions = listaSelectOptions([]);
          return;
        }
        const data = await response.json();
        if (this.form.origen !== origen) return;
        this.listaOptions = listaSelectOptions(data.listas);
      } catch (error) {
        console.error('Error al cargar Listas destinatarios', error);
        this.listaOptions = listaSelectOptions([]);
      }
    },
    onTicketIdInput() {
      this.clearFieldError('ticket_id');
    },
    nombreSecuencia(choice) {
      if (choice.value === 'Seguimiento' && this.siguienteSeguimiento) {
        return 'Seguimiento ' + this.siguienteSeguimiento;
      }
      return choice.value;
    },
    secuenciaDeshabilitada(choice) {
      if (this.incidenciaCerrada) return true;
      return choice.value === 'Inicio' && this.aperturaBloqueada;
    },
    tooltipSecuencia(choice) {
      if (this.incidenciaCerrada) return INCIDENCIA_CERRADA;
      if (choice.value === 'Inicio' && this.aperturaBloqueada) {
        return 'Ya hay un comunicado de esta incidencia. Inicio no se puede repetir.';
      }
      return undefined;
    },
    armAlertDismiss() {
      clearTimeout(this._alertTimer);
      this._alertTimer = setTimeout(() => {
        this.showSuccessAlert = false;
        this.showWarningAlert = false;
        this.showErrorAlert = false;
      }, ALERT_DISMISS_MS);
    },
    scheduleComunicadoAnterior() {
      clearTimeout(this._anteriorTimer);
      this.aperturaBloqueada = false;
      this.incidenciaCerrada = false;
      this.siguienteSeguimiento = null;
      const queried = String(this.form.ticket_id ?? '').trim();
      const queriedOceane = String(this.form.oceane ?? '').trim();
      if (!queried) return;
      const requestEpoch = this._formEpoch;
      const requestId = ++this._anteriorRequestId;
      this._anteriorTimer = setTimeout(() => {
        this.cargarComunicadoAnterior(queried, queriedOceane, requestEpoch, requestId);
      }, ENVIO_SMS_ANTERIOR_DEBOUNCE_MS);
    },
    async cargarComunicadoAnterior(queried, queriedOceane, requestEpoch, requestId) {
      const stillCurrent = () => shouldApplyComunicadoAnterior({
        epoch: this._formEpoch,
        requestEpoch,
        requestId,
        currentRequestId: this._anteriorRequestId,
        sending: this.sending,
        ticketId: this.form.ticket_id,
        queriedTicketId: queried,
        oceane: this.form.oceane,
        queriedOceane,
      });
      if (!stillCurrent()) return;
      try {
        const response = await fetch(
          'api/envio-sms/comunicado-anterior?ticket_id='
            + encodeURIComponent(queried)
            + '&oceane='
            + encodeURIComponent(queriedOceane),
          {
            method: 'GET',
            headers: auth.getAuthHeader(),
          },
        );
        if (!stillCurrent() || !response.ok) return;
        const data = await response.json().catch(() => ({}));
        if (!stillCurrent()) return;
        this.incidenciaCerrada = Boolean(data.cerrado);
        this.siguienteSeguimiento = data.cerrado ? null : (Number(data.siguiente_seguimiento) || 1);
        if (data.cerrado) {
          this.aperturaBloqueada = true;
          if (data.comunicado) {
            const filled = applyComunicadoAnterior(this.form, data.comunicado);
            filled.sequence = '';
            this.form = filled;
            for (const field of Object.keys(data.comunicado)) {
              this.clearFieldError(field);
            }
          } else if (this.form.sequence) {
            this.form.sequence = '';
          }
          this.clearFieldError('sequence');
          return;
        }
        if (!data.comunicado) return;
        const filled = applyComunicadoAnterior(this.form, data.comunicado);
        filled.sequence = sequenceAfterComunicadoAnterior(filled.sequence);
        this.form = filled;
        this.aperturaBloqueada = true;
        this.clearFieldError('sequence');
        for (const field of Object.keys(data.comunicado)) {
          this.clearFieldError(field);
        }
      } catch (error) {
        console.error('Error al cargar el Comunicado anterior', error);
      }
    },
    limpiar() {
      clearTimeout(this._enviarCooldownTimer);
      clearTimeout(this._anteriorTimer);
      this._formEpoch += 1;
      this.form = emptyEnvioSmsForm(this.defaultOrigen || '');
      this.aperturaBloqueada = false;
      this.incidenciaCerrada = false;
      this.siguienteSeguimiento = null;
      this.fieldErrors = {};
      this.sending = false;
      clearTimeout(this._alertTimer);
      this.showSuccessAlert = false;
      this.showWarningAlert = false;
      this.showErrorAlert = false;
      this.successAlertText = '';
      this.warningAlertText = '';
      this.errorAlertText = '';
    },
    async enviar() {
      if (this.incidenciaCerrada) {
        this.errorAlertText = INCIDENCIA_CERRADA;
        this.showErrorAlert = true;
        this.showSuccessAlert = false;
        this.showWarningAlert = false;
        this.armAlertDismiss();
        return;
      }
      if (this.sending || !this.permisosCargados) return;

      const result = validateEnvioSmsForm(this.form);
      if (!result.ok) {
        this.fieldErrors = result.fieldErrors;
        this.showSuccessAlert = false;
        this.showWarningAlert = false;
        this.showErrorAlert = false;
        this.$nextTick(() => {
          const invalid = this.$el.querySelector(
            'input.is-invalid, select.is-invalid, textarea.is-invalid',
          );
          if (invalid && typeof invalid.focus === 'function') invalid.focus();
        });
        return;
      }

      this._formEpoch += 1;
      this.fieldErrors = {};
      this.sending = true;
      this.showSuccessAlert = false;
      this.showWarningAlert = false;
      this.showErrorAlert = false;

      const payload = assembleEnvioSmsPayload(this.form);

      try {
        const response = await fetch('api/envio-sms', {
          method: 'POST',
          headers: auth.getAuthHeader(),
          body: JSON.stringify(payload),
        });
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          this.errorAlertText = data.message || GENERIC_ERROR_ALERT_TEXT;
          this.showErrorAlert = true;
          this.armAlertDismiss();
          return;
        }

        const alert = envioResultAlert(data);
        if (alert.kind === 'error') {
          this.errorAlertText = alert.text;
          this.showErrorAlert = true;
        } else if (alert.kind === 'warning') {
          this.warningAlertText = alert.text;
          this.showWarningAlert = true;
        } else {
          this.successAlertText = alert.text;
          this.showSuccessAlert = true;
        }
        this.armAlertDismiss();
      } catch (error) {
        console.error('Error en Envío SMS', error);
        this.errorAlertText = GENERIC_ERROR_ALERT_TEXT;
        this.showErrorAlert = true;
        this.armAlertDismiss();
      } finally {
        clearTimeout(this._enviarCooldownTimer);
        this._enviarCooldownTimer = setTimeout(() => {
          this.sending = false;
        }, ENVIAR_COOLDOWN_MS);
      }
    },
  },
};
</script>

<style scoped>
.envio-sms-page {
  --ink: #1b2740;
  --ink-soft: #5c6b86;
  --line: #d5deea;
  --sheet: #f3f6fa;
  --field: #8b97ab;
  --binding: #ff7900;
  --seguimiento: #c2410c;
  --cierre: #0f6e6a;
  --emergencia: #9b1c3c;
  margin-top: -0.75rem;
  padding-top: 0.65rem;
  background: #fff;
  color: var(--ink);
}

.envio-sms-formulario {
  max-width: none;
  margin-left: auto;
  margin-right: auto;
}

.envio-sms-sheet {
  background: var(--sheet);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 0.8rem 1rem 0.7rem;
}

.envio-sms-cabecera {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  margin-bottom: 0.6rem;
}

.envio-sms-origen {
  flex: 0 1 16rem;
  width: 16rem;
  margin-bottom: 0;
}

.envio-sms-clave {
  margin-bottom: 0.6rem;
}

.envio-sms-mando {
  display: grid;
  grid-template-columns: minmax(12rem, 0.9fr) minmax(18rem, 1.35fr) auto;
  gap: 0.55rem 1rem;
  align-items: end;
}

.envio-sms-datos,
.envio-sms-grid-4 {
  display: grid;
  gap: 0.55rem 0.85rem;
  margin-top: 0.65rem;
}

.envio-sms-datos {
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1.25fr) 11.5rem 9.5rem;
}

.envio-sms-grid-4 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.envio-sms-acciones {
  grid-column: 1 / -1;
}

.envio-sms-formulario #seccionCabecera p {
  text-align: left;
  padding-left: 0;
  margin-bottom: 0;
}

.envio-sms-title {
  display: block;
  font-size: 1.45rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--ink);
}

.envio-sms-title::after {
  content: "";
  display: block;
  width: 2.25rem;
  height: 3px;
  margin-top: 0.35rem;
  background: var(--binding);
}

.envio-sms-lead {
  margin-top: 0.55rem;
  color: var(--ink-soft);
  font-size: 0.95rem;
}

.envio-sms-secuencia {
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;
}

.envio-sms-bloque-titulo {
  margin: 0 0 0.7rem;
  padding: 0;
  float: none;
  width: auto;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--ink);
}

.envio-sms-bloque {
  margin-top: 1.45rem;
}

.envio-sms-bloque-primero {
  margin-top: 0.15rem;
}

.envio-sms-fin {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.45rem 1rem;
  margin-top: 0.6rem;
}

.envio-sms-bloque-lead {
  margin: -0.35rem 0 0.8rem;
  color: var(--ink-soft);
  font-size: 0.84rem;
  line-height: 1.4;
}

.envio-sms-secuencia-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.4rem;
}

.envio-sms-placa {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  min-height: calc(1.5em + 0.56rem + 2px);
  margin: 0;
  padding: 0 0.65rem;
  border: 1px solid var(--line);
  border-left: 4px solid var(--ink);
  border-radius: 6px;
  background: #fff;
  color: var(--ink);
  cursor: pointer;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}

.envio-sms-placa--seguimiento {
  border-left-color: var(--seguimiento);
}

.envio-sms-placa--cierre,
.envio-sms-placa--final {
  border-left-color: var(--cierre);
}

.envio-sms-placa input {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.envio-sms-placa-name {
  font-size: 0.92rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.envio-sms-placa-hint {
  color: var(--ink-soft);
  font-size: 0.82rem;
  line-height: 1.3;
}

.envio-sms-placa:hover:not(.is-selected, .is-disabled) {
  background: #f4f7fb;
}

.envio-sms-placa.is-disabled,
.envio-sms-placa.is-disabled:hover {
  background: #f3f5f8;
  color: var(--ink-soft);
  cursor: not-allowed;
}

.envio-sms-placa.is-disabled input {
  cursor: not-allowed;
}

.envio-sms-apertura-nota {
  margin-top: 0.55rem;
}

.envio-sms-placa:focus-within {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

.envio-sms-placa.is-selected {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}

.envio-sms-placa--seguimiento.is-selected {
  background: var(--seguimiento);
  border-color: var(--seguimiento);
}

.envio-sms-placa--cierre.is-selected,
.envio-sms-placa--final.is-selected {
  background: var(--cierre);
  border-color: var(--cierre);
}

.envio-sms-placa.is-selected .envio-sms-placa-hint {
  color: rgba(255, 255, 255, 0.84);
}

.envio-sms-secuencia.is-invalid .envio-sms-placa:not(.is-selected) {
  border-color: var(--emergencia);
  background: #fde8ec;
}

.envio-sms-clasificacion {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem 1.75rem;
  margin-top: 0.9rem;
}

.envio-sms-estado {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.35;
}

.envio-sms-severidad {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.envio-sms-severidad-label {
  flex: 1 0 100%;
  margin: 0 0 0.3rem;
  padding: 0;
  float: none;
  width: auto;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.2;
}

.envio-sms-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: 0;
  min-height: calc(1.5em + 0.56rem + 2px);
  padding: 0 0.8rem;
  border: 1px solid var(--field);
  border-radius: 4px;
  background: #fff;
  color: var(--ink);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}

.envio-sms-chip input {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.envio-sms-chip:focus-within {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

.envio-sms-chip.is-selected {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}

.envio-sms-chip--emergencia.is-selected {
  background: var(--emergencia);
  border-color: var(--emergencia);
}

.envio-sms-chip:has(input.is-invalid):not(.is-selected) {
  border-color: var(--emergencia);
  background: #fde8ec;
}

.envio-sms-id-row,
.envio-sms-grid-3,
.envio-sms-destino {
  display: grid;
  gap: 0.75rem 1rem;
}

.envio-sms-id-row {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);
}

.envio-sms-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 0.65rem;
}

.envio-sms-destino {
  grid-template-columns: repeat(auto-fit, minmax(16rem, 22rem));
}

.envio-sms-cuando,
.envio-sms-fin-cuando {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
}

.envio-sms-cuando {
  margin-top: 0.75rem;
}

.envio-sms-field-gap {
  margin-top: 0.75rem;
}

.envio-sms-gestor {
  flex: 1 1 16rem;
  min-width: 12rem;
}

.envio-sms-field {
  margin-bottom: 0;
}

.envio-sms-formulario :deep(.form-label) {
  margin-bottom: 0.3rem;
  color: var(--ink);
  font-size: 0.82rem;
  font-weight: 600;
}

.envio-sms-mark {
  margin-left: 0.35rem;
  color: var(--ink-soft);
  font-size: 0.75rem;
  font-weight: 400;
}

.envio-sms-req {
  margin-left: 0.15rem;
  color: var(--binding);
  font-weight: 700;
}

.envio-sms-hint {
  margin: 0.35rem 0 0;
  color: var(--ink-soft);
  font-size: 0.8rem;
  line-height: 1.35;
}

.envio-sms-fin-check {
  margin-top: 0.1rem;
}

.envio-sms-fin-cuando {
  margin-top: 0.75rem;
}

.envio-sms-field-fecha,
.envio-sms-field-hora {
  flex: 0 0 auto;
}

.envio-sms-field-fecha :deep(.form-control) {
  width: 11.2rem;
  max-width: 100%;
}

.envio-sms-field-hora :deep(.form-control) {
  width: 8.2rem;
  max-width: 100%;
}

.envio-sms-formulario :deep(.form-control),
.envio-sms-formulario :deep(.form-select) {
  border-color: var(--field);
  border-radius: 4px;
  color: var(--ink);
  padding-top: 0.28rem;
  padding-bottom: 0.28rem;
  min-height: calc(1.5em + 0.56rem + 2px);
}

.envio-sms-formulario :deep(textarea.form-control) {
  min-height: 0;
}

.envio-sms-formulario :deep(.form-control:focus),
.envio-sms-formulario :deep(.form-select:focus) {
  border-color: var(--ink);
  box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);
}

.envio-sms-formulario :deep(.form-control.is-invalid),
.envio-sms-formulario :deep(.form-select.is-invalid),
.envio-sms-formulario :deep(textarea.is-invalid) {
  border-color: var(--emergencia);
  background-color: #fde8ec;
}

.envio-sms-resizable {
  resize: vertical;
  overflow-y: auto;
}

.envio-sms-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.7rem;
  padding-top: 0.6rem;
  border-top: 1px solid var(--line);
}

.envio-sms-footer-status {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.envio-sms-ready {
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.86rem;
  line-height: 1.35;
}

.envio-sms-ready--faltan {
  color: var(--emergencia);
  font-weight: 600;
}

.envio-sms-footer-alerts {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 50%;
  display: flex;
  align-items: center;
  margin: 0;
  overflow: visible;
  pointer-events: none;
  transform: translateY(-50%);
}

.envio-sms-footer-alerts :deep(.alert) {
  width: 100%;
  height: auto;
  min-height: 2.6rem;
  margin: 0;
  padding: 0.55rem 0.75rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  line-height: 1.25;
  pointer-events: auto;
}

.envio-sms-footer-alerts :deep(.alert > *) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.envio-sms-footer-alerts :deep(.btn-close) {
  flex-shrink: 0;
  align-self: center;
  background-size: 0.8em;
  opacity: 0.7;
  box-shadow: none;
}

.envio-sms-footer-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 0.5rem;
  justify-content: flex-end;
}

.envio-sms-footer-actions :deep(.btn:focus-visible) {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

@media (max-width: 760px) {
  .envio-sms-sheet {
    padding: 0.85rem 0.8rem 0.75rem;
  }

  .envio-sms-cabecera {
    flex-direction: column;
  }

  .envio-sms-origen {
    flex: 0 0 auto;
    width: 100%;
  }

  .envio-sms-mando,
  .envio-sms-datos,
  .envio-sms-secuencia-grid,
  .envio-sms-id-row,
  .envio-sms-grid-3,
  .envio-sms-grid-4 {
    grid-template-columns: 1fr;
  }

  .envio-sms-placa {
    min-height: 0;
  }

  .envio-sms-field-fecha,
  .envio-sms-field-hora,
  .envio-sms-gestor {
    flex: 1 1 100%;
  }

  .envio-sms-field-fecha :deep(.form-control),
  .envio-sms-field-hora :deep(.form-control) {
    width: 100%;
  }

  .envio-sms-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .envio-sms-footer-actions :deep(.btn) {
    flex: 1 1 auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .envio-sms-placa,
  .envio-sms-chip {
    transition: none;
  }
}
</style>
